var z = Object.defineProperty;
var _ = (e, n, t) => n in e ? z(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var l = (e, n, t) => (_(e, typeof n != "symbol" ? n + "" : n, t), t);
import k from "bowser";
import { filterXSS as I } from "xss";
import R from "scroll-into-view";
import { snakeCase as A, merge as W, get as O, debounce as j, throttle as L } from "lodash-es";
const q = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
function G(e, n) {
  return n.reduce((t, r) => (t[r[e]] = r) && t, {});
}
const m = /* @__PURE__ */ Object.create(null);
function ee(e, n) {
  e = P(e), m[e] || (m[e] = /* @__PURE__ */ Object.create(null));
  const t = m[e];
  return (...r) => {
    n && (r = n(r));
    const s = r.toString();
    return t[s] || (r = r.filter((o) => o !== void 0), t[s] = e + "." + r.map((o) => P(o)).join(".")), t[s];
  };
}
function P(e) {
  return e.split(".").map((n) => A(n)).join(".");
}
function te(e, n = ".", t, r) {
  const s = /* @__PURE__ */ Object.create(null);
  return function o(i, p) {
    Object.keys(i).forEach(function(a) {
      const u = p.concat([a]), c = i[a];
      r && r(a, c) || (typeof c == "object" && (!t || !t(c, a)) ? o(c, u) : s[u.join(n)] = c);
    });
  }(e, []), s;
}
const g = ["B", "kB", "MB", "GB", "TB"];
function x(e, n = "B") {
  const t = g.indexOf(n);
  if (t === -1)
    throw new Error(
      'Unknown byte unit: "' + n + '" expects one of: ' + g.join(", ")
    );
  if (e >= 1024) {
    const r = g[t + 1];
    return r ? x(Math.floor(e / 1024), r) : e + n;
  } else if (e < 1) {
    const r = g[t - 1];
    return r ? x(Math.floor(e * 1024), r) : e + n;
  }
  return e + n;
}
const ne = (e, n, t, r) => {
  const s = e.indexOf(n), o = e.indexOf(t);
  return o !== -1 && s !== -1 ? (s < o ? -1 : 1) * r : s !== -1 ? 1 * r : o !== -1 ? -1 * r : r;
};
function re(e) {
  return JSON.stringify(e, null, 2);
}
function se(e) {
  return e && (e = e.replace(/\s/g, ""), e.substr(0, 4) + " **** **** " + e.substr(-4));
}
function oe(...e) {
  return Object.assign.apply(Object, [{}, ...e]);
}
function ie(e) {
  return typeof e == "function" ? e() : e;
}
const ce = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,63}$/i, ue = /^(\*\.)*?([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+)$/i, S = typeof window < "u", f = S ? k.getParser(window.navigator.userAgent) : null, F = f == null ? void 0 : f.satisfies({
  ie: "<20",
  safari: "<7",
  chrome: "<40",
  firefox: "<60",
  android: "<4",
  iOS: {
    firefox: "<13"
  }
});
function ae() {
  const e = document.querySelector('meta[name="csrf-token"]');
  return e ? e.getAttribute("content") : null;
}
const U = f == null ? void 0 : f.satisfies({
  ie: ">=1"
});
function le() {
  return !!F;
}
function fe() {
  return !!U;
}
function de(e) {
  const n = document.cookie.split("; ").find((t) => t.startsWith(`${e}=`));
  return n ? n.split("=")[1] : "";
}
function he(e) {
  document.readyState === "complete" || document.readyState === "interactive" ? setTimeout(e, 1) : document.addEventListener("DOMContentLoaded", e);
}
const pe = (e, n) => {
  const t = new RegExp(q(n), "gi");
  return I(e.replace(t, (r) => `<b>${r}</b>`));
}, ge = (e = "div") => ({
  render: function(n) {
    return n(e, this.$slots.default);
  }
});
function me(e, n = {}, t) {
  return e ? (n = W(
    {
      // cofiguration ref: https://www.npmjs.com/package/scroll-into-view#how
      time: 200
    },
    n
  ), {
    cancel: R(e, n, t),
    el: e
  }) : null;
}
function be() {
  S && window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
}
function we(e) {
  if (!e) {
    if (!S)
      return {};
    e = window.location.href;
  }
  const n = {}, t = document.createElement("a");
  t.href = e;
  const s = t.search.substring(1).split("&");
  for (let o = 0; o < s.length; o++) {
    const i = s[o].split("=");
    n[i[0]] = decodeURIComponent(i[1]);
  }
  return n;
}
function Se(e, n) {
  return K(e, n);
}
const K = (e, n, t) => e && e.replace(
  /:([.\w]+)/g,
  (r, s) => O(n, s) || O(t, s) || `:${s}`
);
function Oe(e, n) {
  const t = n ? n.ctrlKey || n.metaKey : !1;
  window.open(
    e,
    t ? "_blank" : "_self"
  ), window.location.href.startsWith(e.split("#")[0]) && e.includes("#") && window.location.reload();
}
const Pe = (e) => e.replace(/<b>|<\/b>/g, "");
function xe() {
  ["borderBoxSize", "contentBoxSize"].forEach((e) => {
    window.ResizeObserver && !ResizeObserverEntry.prototype.hasOwnProperty(e) && Object.defineProperty(ResizeObserverEntry.prototype, e, {
      get: function() {
        return C(this.target, e);
      }
    });
  });
}
function C(e, n) {
  const t = getComputedStyle(e), r = parseFloat(t.width), s = parseFloat(t.height), o = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), i = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), p = parseFloat(t.borderLeftWidth) + parseFloat(t.borderRightWidth), a = parseFloat(t.borderTopWidth) + parseFloat(t.borderBottomWidth);
  let u = 0, c = 0;
  switch (n) {
    case "borderBoxSize":
      t.boxSizing === "border-box" ? (u = r, c = s) : (u = r + o + p, c = s + i + a);
      break;
    case "contentBoxSize":
      t.boxSizing === "border-box" ? (u = r - o - p, c = s - i - a) : (u = r, c = s);
      break;
  }
  return [{ inlineSize: u, blockSize: c }];
}
const b = /* @__PURE__ */ new Map(), Ee = {
  bind: (e, n, t) => {
    const r = (s) => {
      e !== s.target && !e.contains(s.target) && (document.contains(s.target) || !N(s, e)) && t.context[n.expression](s);
    };
    b.set(e, r), document.body.addEventListener("click", r);
  },
  unbind: (e) => {
    document.body.removeEventListener("click", b.get(e)), b.delete(e);
  }
};
function N(e, n) {
  var r;
  const t = (r = e.composedPath) == null ? void 0 : r.call(e);
  return t != null && t.includes ? t.includes(n) : !1;
}
const w = /* @__PURE__ */ new Map(), ve = {
  bind: (e, n, t) => {
    const r = (s) => {
      t.context[n.expression](s);
    };
    w.set(e, r), document.body.addEventListener("click", r);
  },
  unbind: (e) => {
    document.body.removeEventListener("click", w.get(e)), w.delete(e);
  }
};
var $ = /* @__PURE__ */ ((e) => (e.Sweden = "se", e.Slovakia = "sk", e.Czechia = "cz", e.Hungary = "hu", e))($ || {}), M = /* @__PURE__ */ ((e) => (e.WEBSUPPORT = "ws", e.LOOPIA = "lp", e))(M || {}), V = /* @__PURE__ */ ((e) => (e.WEBSUPPORT_SK = "sk-ws", e.SK_WEBSUPPORT_CZ = "cz-ws", e.WEBSUPPORT_HU = "hu-ws", e.WEBSUPPORT_SE = "se-ws", e.SK_WEBSUPPORT_HU = "hu-skws", e.ACTIVE_24_SK = "sk-a24", e.ACTIVE_24_CZ = "cz-a24", e.SK_WEBSUPPORT_AT = "at-ws", e.LOOPIA_SE = "se-lp", e.LOOPIA_NO = "no-lp", e.ACTIVE_24_WE = "we-a24", e))(V || {});
function ye(e, n) {
  return e === 0 || e === 1 ? e : e >= 2 && e <= 4 ? 2 : n === 4 ? 3 : 2;
}
const Be = {
  en: "English",
  sk: "Slovensky",
  cs: "Česky",
  cz: "Česky",
  hu: "Magyar",
  de: "Deutsch",
  sv: "Swedish",
  se: "Swedish",
  xx: "Crowdin"
}, d = /* @__PURE__ */ Object.create(null);
function Te(e, n, t) {
  const r = JSON.stringify(n);
  localStorage.setItem(e, r), t && (d[e] = n);
}
function ze(e, n) {
  if (n && d[e] !== void 0)
    return d[e];
  try {
    let t = localStorage.getItem(e);
    return t = t ? JSON.parse(t) : void 0, n && t !== void 0 && (d[e] = t), t;
  } catch {
    return localStorage.removeItem(e), null;
  }
}
function _e(e) {
  localStorage.removeItem(e), delete d[e];
}
const h = /* @__PURE__ */ Object.create(null);
function ke(e, n, t) {
  const r = JSON.stringify(n);
  sessionStorage.setItem(e, r), t && (h[e] = n);
}
function Ie(e, n) {
  if (n && h[e] !== void 0)
    return h[e];
  try {
    let t = sessionStorage.getItem(e);
    return t = t ? JSON.parse(t) : void 0, n && t !== void 0 && (h[e] = t), t;
  } catch {
    return sessionStorage.removeItem(e), null;
  }
}
function Re(e) {
  sessionStorage.removeItem(e), delete h[e];
}
const H = 20, v = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", y = "abcdefghijklmnopqrstuvwxyz", B = "0123456789", T = "!#$%&()*+,-./:;<=>?@[]^_`{|}~", E = v + y + B + T, D = (e) => {
  let [n, t, r, s] = [!1, !1, !1, !1];
  for (let o = 0; o < e.length; o++) {
    const i = e.charAt(o);
    v.includes(i) && (n = !0), y.includes(i) && (t = !0), B.includes(i) && (r = !0), T.includes(i) && (s = !0);
  }
  return n && t && r && s;
};
function Ae() {
  let e;
  do
    e = Array.from(crypto.getRandomValues(new Uint32Array(H))).map((n) => E[n % E.length]).join("");
  while (!D(e));
  return e;
}
class We {
  constructor(n = {}) {
    l(this, "queue", []);
    l(this, "pendingPromises", []);
    l(this, "workingOnPromise", !1);
    l(this, "executeAllImmediately", !1);
    // don't queue, run all promises immediately
    l(this, "options");
    this.options = n;
  }
  enqueue(n) {
    return new Promise((t, r) => {
      this.queue.push({
        promise: n,
        resolve: t,
        reject: r
      }), this.dequeue();
    });
  }
  // performs next step - take next promise in queue
  dequeue() {
    if (this.workingOnPromise && !this.executeAllImmediately)
      return !1;
    const n = this.queue.shift();
    if (n) {
      this.workingOnPromise = !0, this.executeAllImmediately && this.dequeue();
      const t = n.promise();
      return this.pendingPromises.push(
        t.then((r) => {
          n.resolve(r);
        }).catch((r) => {
          n.reject(r);
        }).finally(() => {
          var r, s;
          this.workingOnPromise = !1, this.pendingPromises.splice(
            this.pendingPromises.indexOf(t),
            1
          ), !this.pendingPromises.length && !this.queue.length && ((s = (r = this.options).onComplete) == null || s.call(r)), this.dequeue();
        })
      ), !0;
    } else
      return !1;
  }
}
function je(e = 300) {
  return (n, t) => ({
    configurable: !0,
    enumerable: !1,
    value: j(n[t], e)
  });
}
function Le(e = 300, n) {
  return (t, r) => ({
    configurable: !0,
    enumerable: !1,
    value: L(t[r], e, n)
  });
}
export {
  M as Company,
  V as CompanyId,
  $ as Country,
  je as Debounce,
  We as PromisesQueue,
  xe as ResizeObserverEntryPolyfill,
  Le as Throttle,
  oe as assign,
  x as byteConvert,
  g as byteUnits,
  se as cardHash,
  ne as customValuesCompare,
  Pe as deemphasiseQuery,
  he as docReady,
  ce as emailPattern,
  pe as emphasiseQuery,
  q as escapeRegExp,
  ie as evaluate,
  te as flatten,
  Ae as generatePassword,
  de as getCookieValue,
  ae as getCsrfToken,
  ze as getItem,
  we as getQueryParams,
  Ie as getSessionItem,
  ee as getSnakedKeyFactory,
  S as isBrowser,
  fe as isIE,
  le as isOutdatedBrowser,
  re as jsonFilter,
  Be as languageNames,
  G as mapBy,
  Oe as redirect,
  _e as removeItem,
  Re as removeSessionItem,
  Se as replacePlaceholders,
  me as scrollToElement,
  be as scrollToTop,
  Te as setItem,
  ke as setSessionItem,
  ge as simpleWrapperCmp,
  ye as skCzPluralization,
  P as snakeCaseKeepDots,
  K as urlTemplate,
  ue as webPattern,
  ve as wsAnyClick,
  Ee as wsClickOutside
};
//# sourceMappingURL=index.es.js.map
